import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router"
import { ClienteLogin } from '../../../views/login/cliente_login';
import { UbicacionEntity } from "../../../views/masivos/datosGenerales/entities/ubicacion_entity"
import { CIUDADES } from "../cabecera/entity/ciudades";
import { Cliente } from "../../../views/login/cliente_login";
import { ClienteIndividualEntity } from "../../../views/masivos/datosGenerales/entities/datos_generales_individual_entity";
import { DatosGeneralesService } from "../../../views/masivos/datosGenerales/datos-generales.service";
import { HandleError } from "../utils/handleError.component";
import { ConsultarUsuarioMasivos } from "../utils/consultarUsuarioMasivos";
import { SessionStorageService, SessionStorage } from "ngx-webstorage";


declare var jQuery: any;

@Component({
    selector: 'cabeceracorporativo',
    templateUrl: 'cabeceracorporativo.template.html',
    styleUrls: ["cabeceracorporativo.style.css"]
})

export class Cabeceracorporativo implements OnInit {
    NombreUsuario: string;
    usuario: ClienteLogin;
    comboCiudad: UbicacionEntity[];
    comboempresa: UbicacionEntity;
    inicial: number;
    lengthCombo: boolean;
    nombreUser: Cliente;
    clienteMasivosIndividual: ClienteIndividualEntity;

    constructor(private sesionStorageService: SessionStorageService, private router: Router, private datosGeneralesIndividualSevice: DatosGeneralesService, private handleError: HandleError, private consultarMasivo: ConsultarUsuarioMasivos) { }

    ngOnInit(): void {
            this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
           console.log(this.usuario);
            this.consultarTodo();
            this.sesionStorageService.observe("usuario").subscribe(v => {
                this.usuario = jQuery.parseJSON(v);
                this.consultarTodo();
            });
           
    }

    consultarTodo(){
       let usr;
            if (this.usuario != null) {
                if (this.usuario.Corporativo != null) {
                    
                    if (this.usuario.Corporativo.length > 1) {
                        this.comboCiudad = [];
                        
                        
                        this.lengthCombo = this.usuario.Corporativo.length > 1 ? true : false;
                        this.usuario.Corporativo.forEach(element => {
                            this.comboempresa = new UbicacionEntity();
                            this.comboempresa.Nombre=element.Cliente;
                            this.comboempresa.Codigo=element.Codigocliente;
                            console.log(this.comboempresa);
                            this.comboCiudad.push(this.comboempresa);
                        });
                        let varible=jQuery.parseJSON(this.sesionStorageService.retrieve("usercorporativo"));
                        if(varible==null || varible==undefined)
                        {
                        this.sesionStorageService.store("usercorporativo",JSON.stringify(this.usuario.Corporativo[0]));
                        this.inicial = this.usuario.Corporativo[0].Codigocliente;
                        }
                        else
                        {
                            this.inicial = varible.Codigocliente;
                        }
                        
                    } else {
                        this.lengthCombo = false;
                    }
                }
            }
            try{
            this.NombreUsuario = JSON.parse(this.sesionStorageService.retrieve("NombreUser"));
            }catch(e){
                this.NombreUsuario = this.sesionStorageService.retrieve("NombreUser");
            }
            this.sesionStorageService.observe("NombreUser").subscribe(v => {
                try{
                this.NombreUsuario = JSON.parse(v);
                }catch(e){
                    this.NombreUsuario = v;
                }
            });
    }

    onCiudadChange(codCliente): void {
        this.usuario.Corporativo.forEach(element => {
            if (element.Codigocliente == codCliente) {
                this.sesionStorageService.store("usercorporativo",JSON.stringify(element));
            }
        });
        location.reload();
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/cabeceracorporativo/cabeceracorporativo.component.ts